/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgGift(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7.5 2.75a1.75 1.75 0 100 3.5h3.51a8.778 8.778 0 00-.605-1.389C9.762 3.691 8.833 2.75 7.5 2.75zm3.75 5v3.5h-8.5v-3.5h8.5zm-6.489-1.5a3.25 3.25 0 012.739-5c2.167 0 3.488 1.559 4.22 2.889.102.186.195.371.28.553a9.32 9.32 0 01.28-.553c.732-1.33 2.053-2.889 4.22-2.889a3.25 3.25 0 012.739 5H22a.75.75 0 01.75.75v5a.75.75 0 01-.75.75h-1.25V22a.75.75 0 01-.75.75H4a.75.75 0 01-.75-.75v-9.25H2a.75.75 0 01-.75-.75V7A.75.75 0 012 6.25h2.761zm-.011 6.5v8.5h6.5v-8.5h-6.5zm8 0v8.5h6.5v-8.5h-6.5zm8.5-1.5v-3.5h-8.5v3.5h8.5zm-4.75-5a1.75 1.75 0 000-3.5c-1.333 0-2.262.941-2.905 2.111a8.778 8.778 0 00-.605 1.389h3.51z'
      />
    </svg>
  );
}

export default SvgGift;
